




































































































import InsuranceForm, { InsuranceTypeEnum } from "@/components/report/InsuranceForm.vue";
import { autoCompleteCountryCodes } from "@/lib/CountryCodeHelper";
import { ReportRoleEnum } from "@/lib/enum/ReportRole.enum";
import { TripTypeEnum } from "@/lib/enum/trip-type.enum";
import { emailRuleOptional, phoneRuleOptional } from "@/lib/rules/contactRule";
import { requiredRule } from "@/lib/rules/requiredRule";
import { IWitness, Witness } from "@/models/witness.entity";
import { PartnerModule } from "@/store/modules/partner";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
@Component({
  components: { InsuranceForm },
  filters: {}
})
export default class WitnessForm extends Vue {
  countryCodes = autoCompleteCountryCodes;
  ReportRoleEnum = ReportRoleEnum;
  TripTypeEnum = TripTypeEnum;

  isInsuranceKnown = false;

  @Prop({ default: new Witness() })
  value!: IWitness;

  get required() {
    return [requiredRule()];
  }

  get phoneRule() {
    return [phoneRuleOptional()];
  }

  get emailRules() {
    return [emailRuleOptional()];
  }

  get report() {
    return PartnerModule.report;
  }

  get partner() {
    return PartnerModule.partner;
  }

  get witnessRolesItems() {
    return Object.values(ReportRoleEnum);
  }

  get insuranceTypes() {
    return [InsuranceTypeEnum.MOTORISTS_THIRD_PARTY_LIABILITY_COVERAGE];
  }

  get insuranceType() {
    return InsuranceTypeEnum.MOTORISTS_THIRD_PARTY_LIABILITY_COVERAGE;
  }

  @Watch("isInsuranceKnown")
  toggleInsurance() {
    if (!this.isInsuranceKnown) {
      this.value.insurances = [];
    } else {
      this.value.insurances = [
        { name: "", number: "", type: InsuranceTypeEnum.MOTORISTS_THIRD_PARTY_LIABILITY_COVERAGE }
      ];
    }
  }
}
